export const ADD_FAVORITES = "ADD_FAVORITES";
export const REMOVE_FAVORITES = "REMOVE_FAVORITES";
export const CLEAN_FAVORITES = "CLEAN_FAVORITES";
